import { ActionList, Card, Badge, Banner, Button, Divider, EmptyState, Grid, InlineStack, Modal, Pagination, Popover, ProgressBar, Text, TextField, BlockStack, SkeletonDisplayText } from '@shopify/polaris';
import { MobileVerticalDotsMajor } from '@shopify/polaris-icons';
import React, { useEffect, useState } from 'react';
import { DI, DIProps } from '../../../../../Core';
import { io, Socket } from 'socket.io-client';
import { DefaultEventsMap } from 'socket.io/dist/typed-events';
import { useDebounce } from '../../../../Panel/useDebounce';
import NoResultsFound from '../../../../../Asests/Images/NoResultsFound.png'
import { isAdminLoggedIn } from '../../../Panel/index';
import { RenderSkeletonTemplate } from '../../skeleton/skeleton';
import { useTour } from '../../../../Other/tour';
import { useTranslation } from 'react-i18next';
let socket: Socket<DefaultEventsMap, DefaultEventsMap>;

interface TemplateProps {
    id: string;
    numberOfProductsAssigned: number;
}

const NewTemplate = (props: DIProps) => {
    const { t } = useTranslation();
    const { isOpen, setIsOpen, setCurrentStep, setSteps } = useTour()
    const [importProductModal, setImportProductModal] = useState<boolean>(false);
    const [importProductLoader, setImportProductLoader] = useState<boolean>(false);
    const [popoverActive, setPopoverActive] = useState<boolean[]>([]);
    const [search, setSearch] = useState<string>('');
    const [pageCount] = useState<number>(10);
    const [params, setParams] = useState<any>({ 'count': pageCount });
    const [totalPages, setTotalPages] = useState<number>(0);
    const [loader, setLoader] = useState<boolean>(false);
    const [data, setData] = useState<any>([]);
    const [activateModal, setActivateModal] = useState<boolean>(false);
    const [modalLoader, setmodalLoader] = useState<boolean>(false);
    const [activePage, setActivePage] = useState<number>(1);
    const [isSearchChanged, setIsSearchChanged] = useState<boolean>(false);
    const [profileData, setProfileData] = useState<any>({});
    const [closeValueMappingBanner, setcloseValueMappingBanner] = useState<boolean>(false);
    const [templateData, setTemplateData] = useState<TemplateProps>({
        id: '',
        numberOfProductsAssigned: 0,
    });

    const addNewTemplate = async () => {
        let queuedTasks: any = [];
        let error: string = ''
        setImportProductLoader(true);
        let response = await props.di.GET("connector/get/allQueuedTasks");
        setImportProductLoader(false);
        if (response?.success) {
            queuedTasks = response?.data?.rows;
        }
        queuedTasks?.map((task: any) => {
            if (task?.marketplace == "shopify" && task?.shop_id == props?.redux?.current?.source?.['_id'] && task?.process_code == "saleschannel_product_import") {
                error = "template can't be created";
            }
        });
        if (error) {
            setImportProductModal(true);
            if (isOpen && props.di.globalState.get('start_tour') === 'bulk_upload_1') {
                setIsOpen(false);
                setCurrentStep(0);
                setSteps?.([])
                props?.di.POST('connector/config/saveConfig', {
                    data: [
                        {
                            data: JSON.parse(
                                JSON.stringify(
                                    {
                                        bulk_upload_tour: {
                                            parts_visited: 5,
                                        },
                                    }
                                )
                            ),
                            group_code: 'tour',
                        },
                    ],
                }).then((response) => {
                    if (response.success) {
                        props.di.globalState.set('start_tour', 'bulk_upload_1');
                    }
                    else props.error(t("Something went wrong"))
                })
            }
            return true
        }
        if (isOpen && props.di.globalState.get('start_tour') === 'bulk_upload_1') {
            setIsOpen(false);
            setCurrentStep(0);
            setSteps?.([])
            props?.di.POST('connector/config/saveConfig', {
                data: [
                    {
                        data: JSON.parse(
                            JSON.stringify(
                                {
                                    bulk_upload_tour: {
                                        parts_visited: 2,
                                    },
                                }
                            )
                        ),
                        group_code: 'tour',
                    },
                ],
            }).then((response) => {
                if (response.success) {
                    props.di.globalState.set('start_tour', 'bulk_upload_1');
                }
                else props.error(t("Something went wrong"))
            })
        }
        props.history("../template")
    }

    const deleteTemplate = async () => {
        setmodalLoader(!modalLoader);
        if (templateData['id'] && templateData['id'] != "") {
            let { success, message } = await props.di.GET('connector/profile/deleteProfile', { id: templateData['id'] });
            setmodalLoader(false);
            setActivateModal(!activateModal);
            if (success) {
                props.success(t(message));
                getTotalCount();
                if (data.length === 1) {
                    setParams({ count: pageCount, prev: profileData.prev });
                } else {
                    getAllTemplates();
                }
            }
            else {
                props.error(t("Oops! Some error occured."))
            }
        }
    }

    const handleModalChange = () => {
        deleteTemplate();
        templateData['id'] = '';
        templateData['numberOfProductsAssigned'] = 0;
        setTemplateData({ ...templateData });
    }

    const getTotalCount = async () => {
        // if (!isClearClicked) {
        let params = {};
        if (search) {
            params = {
                name: search
            }
        }
        let res = await props.di.GET('connector/profile/getProfileDataCount', { ...params });
        if (res.success) {
            setTotalPages(Math.ceil(res['total_count'] / pageCount))
        }
        // }
    }

    const getAllTemplates = async () => {
        // if (!isClearClicked) {
        setLoader(true);
        params['useRefinProduct'] = true;
        if (search != '') params['name'] = search;
        else delete params['name'];
        params['sort_order'] = "desc";
        let updatedParams = JSON.parse(JSON.stringify(params));
        if (isSearchChanged) {
            delete updatedParams['next'];
            delete updatedParams['prev'];
        }

        let response = await props.di.GET('connector/profile/getProfileData', updatedParams);
        setLoader(false);
        if (response.success) {
            let popoverArr = new Array(response.data.current_count).fill(false);
            setPopoverActive([...popoverArr])
            setData([...response.data.rows]);
            setActivePage(response?.data?.activePage)
            setProfileData({ ...response.data });
            if (params.prev && response.data.prev === null) {
                setParams({ count: pageCount });
            }
        }
        else {
            setData([]);
        }
        // }
    }

    const handlePreviousPagination = () => {
        setParams({ count: pageCount, prev: profileData.prev })
    }

    const handleNextPagination = () => {
        setParams({ count: pageCount, next: profileData.next })
    }

    const togglePopoverActive = (index: number) => {
        let temPopoverValues = JSON.parse(JSON.stringify(popoverActive));
        temPopoverValues[index] = !temPopoverValues[index];
        setPopoverActive(JSON.parse(JSON.stringify(temPopoverValues)));
    }

    const cloneTemplate = async (id: string, count: number, obj: any, index: number) => {
        let queuedTasks: any = [];
        let error: string = ''
        let response = await props.di.GET("connector/get/allQueuedTasks");
        if (response?.success) {
            queuedTasks = response?.data?.rows;
        }
        queuedTasks?.map((task: any) => {
            if (task?.marketplace == "shopify" && task?.shop_id == props?.redux?.current?.source?.['_id'] && task?.process_code == "saleschannel_product_import") {
                error = "template can't be cloned";
            }
        });
        if (error) {
            togglePopoverActive(index)
            props.error(t("The product import is still in progress, so") + " '" + obj.name + "' " + t("template cannot be cloned until import is complete."));
        }
        else props.history(`../template/${id}`, { replace: false, state: { count: count, clone: true } });
    }

    const editTemplate = async (id: string, count: number, index: number, obj?: any) => {
        let queuedTasks: any = [];
        let error: string = ''
        let response = await props.di.GET("connector/get/allQueuedTasks");
        if (response?.success) {
            queuedTasks = response?.data?.rows;
        }
        queuedTasks?.map((task: any) => {
            if (task?.marketplace == "shopify" && task?.shop_id == props?.redux?.current?.source?.['_id'] && task?.process_code == "saleschannel_product_import") {
                error = "template can't be edited";
            }
        });
        if (error) {
            togglePopoverActive(index)
            props.error(t("The product import is still in progress, so") + " '" + obj.name + "' " + t("template cannot be edited until import is complete."));
        }
        else {
            props.history(`../template/${id}`, { replace: false, state: { count: count, isProductActive: isProductActive(obj) } });
        }
    }

    const editValueMapping1 = (id: string, count: number, templateName: string, attributesMappingId: string, obj: any, type: "json" | "xml", product_type: string) => {
        props.history(`../../config/template/valueMapping/${id}`, {
            replace: false, state: {
                count, templateName, id, attributesMappingId, categoryInfo: obj?.category_id, type, product_type
            }
        })
    }

    const formatDate = (date: Date) => {
        const monthList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        return date.getDate() + ' ' + monthList[date.getMonth()] + ', ' + date.getFullYear();
    }

    const reloadValueMapping = (templateId: any) => {
        props?.di?.POST("amazon/product/valueMapping", {
            "target": {
                "marketplace": "amazon",
                "shopId": props?.redux?.current?.target?.['_id']
            },
            "source": {
                "marketplace": "shopify",
                "shopId": props?.redux?.current?.source?.['_id']
            },
            "profile_id": templateId
        }).then((data: any) => {
            let arr: any = [];
            if (data?.success && data?.count > 0) {
                props.success(t("Value Mapping attributes refreshed."))
                // eligible + updated
            } else if(data?.success) {
                props.success(t("Value Mapping attributes refreshed. But Nothing to update"))
            }else{
                props.error(t("Nothing to refresh and value mapping is not eligible for this template."))
                                // not eligible

            }
        })
    }

    const isProductActive = (productCount: any) => {
        let active = false;
        productCount?.product_count && productCount?.product_count?.map((obj: any) => {
            if (obj?.active_product && obj?.active_product > 0) active = true;
        })
        return active;
    }

    const displayAllTemplatesNew = () => {
        let arr: any = [];
        arr = data.map((obj: any, index: number) => {
            let myItems: any = [
                {
                    id: `template_Btn_Edit_${index}`,
                    content: t('Edit'),
                    onAction: () => {
                        if (obj?.product_update_in_progress) props.error(t("Kindly wait, some products are still assigning."))
                        else editTemplate(obj['_id']['$oid'], obj?.['product_count']?.[0]?.['count'] ?? 0, index, obj)
                    },
                },
                {
                    id: `template_Btn_Clone_${index}`,
                    content: t('Clone'),
                    onAction: () => cloneTemplate(obj['_id']['$oid'], obj?.['product_count']?.[0]?.['count'] ?? 0, obj, index),
                },
                {
                    id: `template_Btn_Delete_${index}`,
                    content: t('Delete'),
                    onAction: () => {
                        if (obj?.product_update_in_progress) props.error(t("Kindly wait, some products are still assigning."))
                        else {
                            setActivateModal(!activateModal);
                            templateData['id'] = obj['_id']['$oid'];
                            templateData['numberOfProductsAssigned'] = obj?.['product_count']?.[0]?.['count'] ?? 0;
                            setTemplateData(templateData);
                        }
                    },
                }
            ];
            if (isAdminLoggedIn()) {
                myItems.push({
                    id: `template_Btn_ReloadValueMapping_${index}`,
                    content: t('Reload Value Mapping'),
                    helpText: t('Reload value mapping when it is necessary!'),
                    onAction: () => reloadValueMapping(obj['_id']['$oid']),
                })
            }
            return (
                <React.Fragment key={index}>
                    <Grid columns={{ xs: 1, sm: 5, md: 5, lg: 5, xl: 5 }} >
                        <Grid.Cell columnSpan={{ xs: 1, sm: 3, md: 3, lg: 3, xl: 3 }}>
                            <InlineStack align='space-between' blockAlign='center' gap="400" wrap={false}>
                                <BlockStack gap="100" inlineAlign='start'>
                                    <Text variant="headingSm" as="h6" breakWord>
                                        {obj?.name.trim()}
                                    </Text>
                                    {obj?.created_at && <Text variant="bodySm" as="p" tone='subdued' id={`template_Text_CreatedOn_${formatDate(new Date(obj?.created_at))}`}>
                                        {t("Created On:")} {formatDate(new Date(obj?.created_at))}
                                    </Text>}
                                    {/* {obj?.category_id?.product_type?.length > 0 ? <></> : obj?.value_mapping && obj?.value_mapping_count && obj?.value_mapping_count > 0 ? <InlineStack gap='200'>
                                        <Badge tone='success'>{`${obj?.value_mapping_count} mapped values`}</Badge>
                                        <Button id={`template_Btn_EditValueMapping_${obj?.attributes_mapping?.$oid}`} variant='plain' onClick={() => editValueMapping1(obj['_id']['$oid'], obj?.['product_count']?.[0]?.['count'] ?? 0, obj['name'], obj?.attributes_mapping?.$oid, { ...obj })}>Edit values</Button>
                                    </InlineStack> :
                                        obj?.value_mapping && <Button variant='plain' onClick={() => editValueMapping1(obj['_id']['$oid'], obj?.['product_count']?.[0]?.['count'] ?? 0, obj['name'], obj?.attributes_mapping?.$oid, { ...obj })}>Map attribute values</Button>} */}

                                    {obj?.value_mapping && <Button variant='plain' onClick={() => editValueMapping1(obj['_id']['$oid'], obj?.['product_count']?.[0]?.['count'] ?? 0, obj['name'], obj?.attributes_mapping?.$oid, { ...obj }, obj?.json_listing ? "json" : "xml", obj?.category_id?.product_type)}>{t("Map attribute values")}</Button>}
                                </BlockStack>
                                {obj?.product_update_in_progress ?
                                    <BlockStack gap='100'>
                                        <div className='text-font-12'>
                                            <Text id={`template_Text_ProductCount_${obj?.product_count?.[0]?.['count'] ?? 0}`} as='span' tone='subdued'>{`${obj?.product_count?.[0]?.['count'] ?? 0}/${obj?.total_count ?? 0} ${t("product(s)")}`}</Text>
                                        </div>
                                        <span className='progress-height-6'>
                                            <ProgressBar progress={obj?.product_count?.[0]?.['count'] == obj?.total_count ? 100 : 40} size="small" />
                                        </span>
                                    </BlockStack> :
                                    <div className="Custom__Badge--Width"><Badge>{`${obj?.product_count?.[0]?.['count'] ?? 0} ${t("product(s)")}`}</Badge></div>
                                }
                            </InlineStack>
                        </Grid.Cell>
                        <Grid.Cell columnSpan={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}>
                            <InlineStack gap={{ xs: "200", sm: "200", md: "200", lg: "400", xl: "400" }} blockAlign='center' align='end'>
                                {obj?.updated_at && <Text variant="bodySm" as="p">
                                    {t("Last Edited:")} {formatDate(new Date(obj?.updated_at))}
                                </Text>}
                                <Popover
                                    active={popoverActive[index]}
                                    activator={<Button id={`template_Btn_Menu_${index}`} onClick={() => togglePopoverActive(index)} icon={MobileVerticalDotsMajor} >
                                    </Button>}
                                    autofocusTarget="first-node"
                                    onClose={() => togglePopoverActive(index)}
                                >
                                    <ActionList
                                        actionRole="menuitem"
                                        items={myItems}
                                    />
                                </Popover>
                            </InlineStack>
                        </Grid.Cell>
                    </Grid>
                    <Divider />
                </React.Fragment>
            )
        });
        return arr;
    }

    useEffect(() => {
        // socket = io.connect("http://localhost:4004");
        // io('https://amazon.websocket.cedcommerce.com/', { path: '/profileWebsocket.demo' });

        socket = io('https://amazon.websocket.cedcommerce.com/', { path: process.env.REACT_APP_WEBSOCKET_PATH, transports: ['websocket', 'polling'] });
        // socket = io.connect("http://localhost:4000");

        socket.on("connect", () => {

            socket.emit('setRoomInfo', {
                'user_id': props.di.user_id,
                'target_shop_id': props?.redux?.current?.target?.['_id'],
                'source_shop_id': props?.redux?.current?.source?.['_id']
            });
        });

        socket.on('disconnect', function () {
        })

        return () => {
            socket.disconnect();
        }
    }, [process.env.REACT_APP_WEBSOCKET_PATH]);

    if (data.length > 0) {
        socket.on("productsUpdate", (info) => {
            let tempData = JSON.parse(JSON.stringify(data));
            tempData.map((tempObj: any) => {
                if (tempObj?.['_id']['$oid'] == info?.['_id']) {
                    getAllTemplates();
                }
            });
            setData(JSON.parse(JSON.stringify(tempData)));
        })
    }
    const debouncedValue = useDebounce(search, 500);

    useEffect(() => {
        getTotalCount();
    }, [debouncedValue]);

    useEffect(() => {
        getAllTemplates();
    }, [params, debouncedValue]);

    return <>
        <Modal
            open={activateModal}
            onClose={() => {
                setActivateModal(!activateModal);
                templateData['id'] = '';
                templateData['numberOfProductsAssigned'] = 0;
                setTemplateData({ ...templateData });
            }}
            title={t(`Are you sure you want to delete this template?`)}
            primaryAction={{
                content: t('Delete'),
                onAction: handleModalChange,
                loading: modalLoader
            }}
            secondaryActions={[{
                content: t('Cancel'), onAction: () => {
                    setActivateModal(!activateModal);
                    templateData['id'] = '';
                    templateData['numberOfProductsAssigned'] = 0;
                    setTemplateData({ ...templateData });
                }
            }]}
        >
            <Modal.Section>{`${t("Total")} ${templateData['numberOfProductsAssigned']} ${t("product(s) are assigned in this template.")}`}</Modal.Section>
        </Modal>
        <BlockStack gap="500">
            <BlockStack gap="200">
                <Text variant="headingMd" as="h6" id='template_Text_ProductTemplates'>
                    {t("Product Templates")}
                </ Text>
                <Text as="p" fontWeight="regular" id='template_Text_ProductTemplatesDescription'>
                    {t("Effortlessly manage and update data of multiple products using Product Templates. These templates empower sellers to efficiently adjust inventory settings, price settings, mapping attributes, and more—all in one go for multiple listings.")}
                </Text>
            </BlockStack>
            <InlineStack align="end">
                <Popover
                    active={importProductModal}
                    onClose={() => { setImportProductModal(false) }}
                    activator={
                        <Button onClick={() => {
                            addNewTemplate();
                        }} loading={importProductLoader} variant="primary" id='bulktour_add_new_template_button'>{t("Add New Template")}</Button>
                    }
                >
                    <Banner tone={'warning'} title={t("Product Import is in Progress")} onDismiss={() => { setImportProductModal(false) }}>
                        <p>{t("The product import is still in progress, so a new template cannot be created until import is complete.")}</p>
                    </Banner>
                </Popover>
            </InlineStack>
            <Divider />
            {!closeValueMappingBanner ? <Banner
                tone="info"
                onDismiss={() => { setcloseValueMappingBanner(true) }}
            >
                <Text as='p'><b>{t("Value Mapping")}</b> {t("is recommended for some templates. We have found some Amazon recommended values for your chosen attributes. Map these attribute values to have greater product visibility on Amazon.")} {t("To know more")}, <Button
                    url="https://support.cedcommerce.com/portal/en/kb/articles/templates-28-3-2025"
                    external
                    variant="plain">{t("check out this guide")}.</Button></Text>
            </Banner> : <></>}
            <BlockStack gap="300">
                {loader ? <div className='custom-valueMapping-textfield-skelton'>
                <SkeletonDisplayText size='medium'/>
                </div> :
                <TextField
                    id='template_TextField_SearchBar'
                    clearButton
                    label=""
                    value={search}
                    autoComplete='off'
                    onChange={(e) => {
                        e = e.toString().replace(/[!$%^&*()@+|~=`\\#{}\[\]:";'<>?,.\/]/gi, "");
                        e = e.toString().replace(/ +/g, ' ');
                        e != " " && setSearch(e);
                        e != " " && setIsSearchChanged(true);
                    }}
                    placeholder={t('Search by template name')}
                    onClearButtonClick={() => setSearch('')}
                />}
                <Card roundedAbove='sm'>
                    <BlockStack gap="500">
                        {
                            loader ? RenderSkeletonTemplate() : data.length > 0 ?
                                <div className='bulk_tour--template-grid'>
                                    <BlockStack gap="500">{displayAllTemplatesNew()}</BlockStack>
                                </div> :
                                <InlineStack gap="400" align="center">
                                    <EmptyState
                                        image={NoResultsFound}
                                        heading={t("No Templates Found")}
                                    />
                                </InlineStack>
                        }
                        {data.length > 0 &&
                            <div className={loader ? 'card_dull' : undefined}>
                                <InlineStack gap="400" align="center">
                                    <Pagination
                                        label={`${activePage}/${totalPages}`}
                                        hasPrevious={profileData.prev !== null}
                                        onPrevious={() => {
                                            setIsSearchChanged(false);
                                            handlePreviousPagination()
                                        }}
                                        hasNext={profileData.next !== null}
                                        onNext={() => {
                                            setIsSearchChanged(false);
                                            handleNextPagination()
                                        }}
                                    />
                                </InlineStack>
                            </div>
                        }
                    </BlockStack>
                </Card>
            </BlockStack>
        </BlockStack>
    </>;
};

export default DI(NewTemplate);